import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Villain } from '../models/villain';
import { CardService } from '../services/card.service';

@Component({
    template: require('./custom-villain-edit.component.html'),
    selector: 'custom-villain-edit'
})
export class CustomVillainEditComponent {
    private editForm: FormGroup;

    private active: boolean = false;
    @Input() public isNew: boolean = false;

    @Input() public set model(villain: Villain) {
        this.editForm.reset(villain);

        this.active = villain !== undefined;
    }

    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() save: EventEmitter<Villain> = new EventEmitter();

    public typeList: Array<string> = [];

    constructor(private service: CardService, private fb: FormBuilder) {
        this.createForm();
    }

    ngOnInit() {
        this.service.fetchTypes()
            .subscribe(data => {
                this.typeList = data;
            });
    }

    private createForm() {
        this.editForm = this.fb.group({
            LegendaryVillainId: 0,
            UserName: "",
            Name: "",
            Type: "",
            Limit: 0,
            BecomeHero: false,
            BecomeMastermind: false
        });
    }

    public onSave(e): void {
        e.preventDefault();
        this.save.emit(this.editForm.value);
        this.active = false;
    }

    public onCancel(e): void {
        e.preventDefault();
        this.closeForm();
    }

    private closeForm(): void {
        this.active = false;
        this.cancel.emit();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/custom/custom-villain-edit.component.ts